import { OrganogramModel } from './OrganogramModel';

export interface OrganogramDto {
    level: number,
    parentId: number | null,    
    organogramList: OrganogramModel[],
    selectedOrganogram: OrganogramModel | null,
    hasOrganograms: boolean
}

export const organogramDtoInitial: OrganogramDto = {
    level: 0,
    parentId: null,    
    organogramList: [],
    selectedOrganogram: null,
    hasOrganograms: false
}; 